module.exports = __webpack_public_path__ + "static/media/avatar@3x.6827c622.png";